
import { mapState } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'

export default {
  components: {
    LazyHydrate,
    'id-diagram-value-description': () => import('~/components/diagram/lazy/ValueDescription.vue')
  },
  props: ['preview'],
  computed: {
    ...mapState({
      licenses: state => state.checkout.licenses
    })
  },
  methods: {
    closeModal () {
      this.$store.dispatch(
        'checkout/setItemPreview',
        {
          visible: false,
          diagram: null,
          images: [],
          $backend: this.$backend
        }
      )
    }
  }
}
